import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import querystring from 'querystring';
import { StateType } from '../../../../../state/state.types';
import makeQueryParamsUtil from '../../../../../../../shared/makeQueryParamsUtil';
import { getQueryParamsFromState } from '../../../../state/utils';
import {
  filterOnSpecificArticleVersion,
  search,
  updateLawArticleId,
} from '../../../../state/actions';

const mapState = ({ queryParams, results }: StateType) => {
  let searchQueryUrl = querystring.stringify(
    makeQueryParamsUtil(
      getQueryParamsFromState({ ...queryParams, userQuery: results.query }),
    ),
  );
  searchQueryUrl += `&original_query_key=${queryParams.originalQueryKey}`;

  return {
    searchQueryUrl,
    lawArticleId: queryParams.lawArticleId,
    filterOnSpecificArticleVersion: queryParams.filterOnSpecificArticleVersion,
  };
};

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  onSelectLawArticleId(articleId: string) {
    dispatch(updateLawArticleId(articleId));
    dispatch(search({ reason: 'restrict-from-snippet' }));
  },
  onFilterOnArticle() {
    dispatch(filterOnSpecificArticleVersion());
    dispatch(search({ reason: 'restrict-from-snippet' }));
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
